import {useAppSelector} from "../../store/hooks";
import {ApplicationVariant} from "../types/ApplicationVariant";

export const useApplicationVariant = () => {
    const modalApplicationVariant = useAppSelector((state) => state.leadModal.applicationVariant);
    const propertyId = useAppSelector((state) => state.leadModal.propertyId);
    // TODO change DEFAULT to PROPERTY_WITH_RETARGETING while bringing pre multilead back, business does not know whether we ultimately want to abandon multilead
    const applicationVariant = modalApplicationVariant ?? ApplicationVariant.DEFAULT;
    // TODO remove if while removing pre multilead, business does not know whether we ultimately want to abandon multilead
    if (applicationVariant === ApplicationVariant.PROPERTY_WITH_RETARGETING && !propertyId) {
        // PROPERTY_WITH_RETARGETING is only available for properties
        return ApplicationVariant.DEFAULT;
    }

    return applicationVariant;
};
import {useAppSelector} from "../../store/hooks";
import {ApplicationVariant} from "../types/ApplicationVariant";

export const useApplicationVariant = () => {
    const modalApplicationVariant = useAppSelector((state) => state.leadModal.applicationVariant);
    const propertyId = useAppSelector((state) => state.leadModal.propertyId);
    // TODO change DEFAULT to PROPERTY_WITH_RETARGETING while bringing pre multilead back, business does not know whether we ultimately want to abandon multilead
    const applicationVariant = modalApplicationVariant ?? ApplicationVariant.DEFAULT;
    // TODO remove if while removing pre multilead, business does not know whether we ultimately want to abandon multilead
    if (applicationVariant === ApplicationVariant.PROPERTY_WITH_RETARGETING && !propertyId) {
        // PROPERTY_WITH_RETARGETING is only available for properties
        return ApplicationVariant.DEFAULT;
    }

    return applicationVariant;
};
